export enum EApplicationDetailTabs {
  Info,
  History,
}
